package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.CHECK_MERCHANT_IBAN_EXISTS
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class CheckMerchantIbanExistsRequestModel(
    val iban: String
) : BaseRequestModel(api = CHECK_MERCHANT_IBAN_EXISTS)
